var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImmutableXLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_688_3312",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H32V32H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_688_3312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0C7.16347 0 0 7.16347 0 16C0 24.8365 7.16347 32 16 32C24.8365 32 32 24.8365 32 16C32 7.16347 24.8365 0 16 0ZM17.3107 11.364L17.9325 10.6378L20.0887 8.12376H22.0391L17.9131 12.9282C17.9131 12.9282 17.4539 12.384 17.2973 12.2021C17.0915 11.9575 17.0975 11.5952 17.3092 11.364H17.3107ZM12.1275 8.12376C12.1275 8.12376 15.5825 12.2587 16.8335 13.5411C17.0334 13.7409 16.9961 14.0034 16.8157 14.2166C16.1506 14.9979 16.1327 15.0114 16.1327 15.0114L10.189 8.12376H12.1275ZM14.9368 20.5346L14.315 21.2608L12.1588 23.7748H10.2084L14.3344 18.9704C14.3344 18.9704 14.7937 19.5146 14.9502 19.6966C15.156 19.9411 15.15 20.3034 14.9383 20.5346H14.9368ZM15.0158 16.3116C13.3368 18.2576 8.61286 23.7733 8.61286 23.7733H6.51631L12.9431 16.3295C13.1489 16.0925 13.1489 15.7346 12.9431 15.5034L6.56552 8.12376H8.58304L14.9979 15.5676C15.1605 15.7868 15.1918 16.1059 15.0158 16.3116ZM20.0902 23.7733L15.7346 18.6945L15.5169 18.4186C15.3111 18.1815 15.3171 17.8117 15.5288 17.5806L23.6466 8.12376H25.6582L17.4911 17.4568C17.2794 17.688 17.2734 18.0578 17.4792 18.2949L22.1912 23.7748H20.0887L20.0902 23.7733ZM23.7987 23.7733C23.7987 23.7733 20.2826 19.6697 19.1105 18.2993C18.9778 18.1428 18.9286 17.931 18.9778 17.7372C19.0136 17.6313 19.0926 17.512 19.1657 17.43L19.71 16.8291L25.7074 23.7719H23.7987V23.7733Z",
    fill: "#000000"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImmutableXLogo);
export default __webpack_public_path__ + "static/media/ImmutableXLogo.4eb4b9448b2ca1cdbd4cec7ad7ffe23d.svg";
export { ForwardRef as ReactComponent };